import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  schema?: object;
  hreflang?: string;
  region?: string;
  localAreas?: string[];
}

const SEO = ({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogImage = "https://storage.googleapis.com/gpt-engineer-file-uploads/xpc6m3MSVoUVwqOVjN2erqrA9O42/social-images/social-1759977509538-FOX2.png",
  schema,
  hreflang = "en-gb",
  region = "GB",
  localAreas = [],
}: SEOProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Geo-targeting */}
      <meta name="geo.region" content={region} />
      {region === "GB" && <meta name="geo.placename" content="United Kingdom" />}
      {localAreas.map((area) => (
        <meta key={area} name="geo.placename" content={area} />
      ))}
      
      {/* Language targeting */}
      {canonical && (
        <>
          <link rel="alternate" hrefLang={hreflang} href={canonical} />
          <link rel="alternate" hrefLang="x-default" href={canonical} />
        </>
      )}
      
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical || "https://4fox.uk/"} />
      <meta property="og:locale" content={hreflang === "en-gb" ? "en_GB" : "en_US"} />
      
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
      
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
